import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";

const defaultState = { place: {}, coords: {}, input: "" };

export const usePlaceStore = defineStore("places", {
  state: () => useLocalStorage("place-storage", defaultState),
  getters: {
    latLng: (state) => {
      return state.coords;
    },
    placeId: (state) => {
      return state.place.place_id;
    },
    formattedAddress: (state) => {
      return state.place.formatted_address;
    },
    lastInput: (state) => {
      return state.input;
    },
  },
  actions: {
    updatePlace(newPlace) {
      this.place = {
        place_id: newPlace.id,
        formatted_address: newPlace.formattedAddress,
        location: newPlace.location,
      };
      this.coords = {
        lat: newPlace.location?.lat(),
        lng: newPlace.location?.lng(),
      };
    },
    updateInput(newInput) {
      this.input = newInput;
    },
  },
});
